/* ALll number constants should go here*/
export const NUMBER_MINUS_ONE = -1
export const NUMBER_ZERO = 0
export const NUMBER_ONE = 1
export const NUMBER_TEN = 10
export const NUMBER_THOUSAND = 1000
export const NUMBER_FIFTY = 50
export const NUMBER_SIXTY = 60
export const NUMBER_NINETY_NINE = 99
export const NUMBER_TRIPLE_NINE = 999
export const NUMBER_HUNDRED = 100
export const NUMBER_TWO = 2
export const NUMBER_THREE = 3
export const NUMBER_FOUR = 4
export const NUMBER_FIVE = 5
export const NUMBER_SIX = 6
export const NUMBER_SEVEN = 7
export const NUMBER_EIGHT = 8
export const NUMBER_NINE = 9
export const NUMBER_ELEVEN = 11
export const NUMBER_TWELVE = 12
export const NUMBER_THIRTEEN = 13
export const NUMBER_FOURTEEN = 14
export const NUMBER_FIFTEEN = 15
export const NUMBER_SIXTEEN = 16
export const NUMBER_SEVENTEEN = 17
export const NUMBER_EIGHTEEN = 18
export const NUMBER_NINETEEN = 19
export const NUMBER_TWENTY = 20
export const NUMBER_THIRTY_TWO = 32
export const NUMBER_ONE_HUNDRED_TWENTY_SIX = 126
export const NUMBER_SIX_HUNDRED = 600
export const NUMBER_FIVE_HUNDRED = 500
export const NUMBER_TWO_HUNDRED = 200
export const NUMBER_FIVE_THOUSAND = 5000
